// https://github.com/jkuri/ng2-datepicker/tree/master/src/ng2-datepicker
import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

import {NgSlimScrollModule} from "ngx-slimscroll";

import {DatePickerComponent} from "./datepicker.component";

@NgModule({
  declarations: [
    DatePickerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgSlimScrollModule,
  ],
  exports: [
    DatePickerComponent,
    NgSlimScrollModule,
    FormsModule,
  ],
})
export class DatePickerModule {
}
